/*
 * Copyright (C) 2019 SADE Innovations Oy - All Rights Reserved
 *
 * NOTICE: This software is owned by SADE Innovations Oy and licensed under SADE Booster license.
 * All dissemination, usage, modification, copying, reproduction, selling and distribution of the
 * software and its intellectual and technical concepts are strictly forbidden without a valid license.
 * Such license can be obtained by issuing a SADE Booster License agreement from SADE Innovations Oy
 * (https://sadeinnovations.com).
 */
import { WallStationESP32HWStateProperties } from "./WallStationESP32HWStateProperties";
import { WallStationESP32HWState } from "./WallStationESP32HWState";
import { ConnectivityUnitHW } from "../ConnectivityUnitHW/ConnectivityUnitHW";
export class WallStationESP32HW extends ConnectivityUnitHW {
    constructor(backend, params) {
        super(WallStationESP32HW.type, backend, params);
    }
    createState(timestamp, version, reported, desired, connectionState) {
        return new WallStationESP32HWState(this.getId(), new WallStationESP32HWStateProperties(reported !== null && reported !== void 0 ? reported : {}), new WallStationESP32HWStateProperties(desired !== null && desired !== void 0 ? desired : {}), timestamp, version, connectionState);
    }
    static instanceOf(device) {
        return device instanceof WallStationESP32HW;
    }
}
WallStationESP32HW.type = "WallStation_ESP32";
